/** Work experience entries — edit here. */

export const EXPERIENCE_ENTRIES = [
  {
    id: "tjarnarskoli",
    title: {
      is: "Forritunarkennari",
      en: "Programming Teacher",
      es: "Profesor de programación",
    },
    org: {
      is: "Tjarnarskóli",
      en: "Tjarnarskóli",
      es: "Tjarnarskóli",
    },
    period: "2026",
    logo: "/assets/tjarmarskoli.png",
    description: {
      is: "kennsla í vefforritun (html, css, javascript) á grunnskólastigi, verkefni og leiðsögn í grunnatriðum.",
      en: "teaching web programming (html, css, javascript) at primary level — assignments and guidance in the fundamentals.",
      es: "enseñanza de programación web (html, css, javascript) en primaria — tareas y orientación en lo básico.",
    },
  },
  {
    id: "hi-student-org",
    title: {
      is: "Kerfisstjóri",
      en: "Systems Administrator",
      es: "Administrador de sistemas",
    },
    org: {
      is: "Nörd, nemendafélag við Háskóla Íslands",
      en: "Nörd, student association at the University of Iceland",
      es: "Nörd, asociación de estudiantes de la Universidad de Islandia",
    },
    period: "2025 — 2026",
    logo: "/assets/nord.svg",
    description: {
      is: "þróun og viðhald bakenda og framenda, stafrænn vettvangur, áreiðanleiki og samstarf við stjórnir.",
      en: "developing and maintaining backend and frontend systems, digital platforms, reliability, and board collaboration.",
      es: "desarrollo y mantenimiento de backend y frontend, plataformas digitales, fiabilidad y colaboración con juntas.",
    },
  },
];

/** Secondary roles — title, org, years only (no bio). */
export const OTHER_EXPERIENCE = [
  {
    id: "golf",
    title: {
      is: "Móttökustjóri",
      en: "Front Desk Manager",
      es: "Responsable de recepción",
    },
    org: {
      is: "Golfklúbbur Mosfellsbæjar",
      en: "Mosfellsbær Golf Club",
      es: "Club de golf de Mosfellsbær",
    },
    period: "2019 — 2023",
  },
  {
    id: "olgerdin",
    title: {
      is: "Áfyllari",
      en: "Beverage Filler",
      es: "Operario de llenado",
    },
    org: {
      is: "Ölgerðin",
      en: "Ölgerðin",
      es: "Ölgerðin",
    },
    period: "2023 — 2025",
  },
];

export const EXPERIENCE_HEADING = {
  is: "reynsla",
  en: "experience",
  es: "experiencia",
};

export const OTHER_EXPERIENCE_HEADING = {
  is: "önnur starfsreynsla",
  en: "other experience",
  es: "otra experiencia laboral",
};
